import './index.less';
import React from 'react';
import { Button, Message } from 'antd';
import { cancelCourse } from '../../api/index.js';


const cancel = (offset, data, refreshData, handleCancel) => {
  cancelCourse({
    id: data.get('id'),
    offset: {
      offset: offset
    }
  }).then(res => {
    if (res.code === 200) {
      Message.success('取消成功');
      refreshData();
      handleCancel();
      return
    }
    Message.error(res.tip);
  })
}

const Cancel = ({
  data,
  offset,
  refreshData,
  handleCancel
}) => {
  return (
    <div>
      <div className='tips'>您将要取消{data.get('from_time').split(' ')[0]} {data.get('from_time').split(' ')[1].slice(0, 5)}的课时</div>
      <div className='tips'>是否确认？</div>
      <div className='dialog-btn'>
        <Button className='confirmbtn' onClick={() => cancel(offset, data, refreshData, handleCancel)}>确 定</Button>
      </div>
    </div>
  )
}

export default Cancel;


// WEBPACK FOOTER //
// ./src/components/dialog/cancel.jsx